import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppsRestService
 *
 * @description
 * This class contains methods used to retrieve information about apps
 * using http requests.
 */
export default class AppsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
    * @ngdoc function
    * @name rest.services.AppsRestService#getById
    * @methodOf rest.services.AppsRestService
    * @function
    *
    * @description
    * Retrieves app information.
    *
    * @returns {Promise} The promise of the call.
    */
    getById(id) {

        return super.getAllAsync(`apps/${id}?lang=${CWCONFIG.language}`);

    }

}

_serviceDependencies.push(AppsRestService);

angular.module('rest.services')
    .service('AppsRestService', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/restServices/appsRestService.js